const XML_ESCAPE_MAP = {
	'&': '&amp;',
	'<': '&lt;',
	'>': '&gt;',
	'"': '&quot;',
	"'": '&apos;',
};

const XML_UNESCAPE_MAP = {
	'&amp;': '&',
	'&lt;': '<',
	'&gt;': '>',
	'&quot;': '"',
	'&apos;': "'",
};

const TO_ESCAPE = /[&<>"']/g;
const TO_UNESCAPE = /&(?:amp|lt|gt|quot|apos);/g;

const doEscape = (ch) => XML_ESCAPE_MAP[ch];
const doUnEscape = (ch) => XML_UNESCAPE_MAP[ch];

export const escapeXML = (s: string): string => s.replace(TO_ESCAPE, doEscape);
export const unescapeXML = (s: string): string => s.replace(TO_UNESCAPE, doUnEscape);

export const Escape = {
	escape: escapeXML,
	unescape: unescapeXML,
};
